import React, { createContext, useContext, useEffect, useState } from "react";

const CompareCtx = createContext(null);
const KEY = "yk_compare";
const MAX = 3;

export function CompareProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    if (typeof window === "undefined") return [];
    try {
      const raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    try { window.localStorage.setItem(KEY, JSON.stringify(slugs)); } catch {}
  }, [slugs]);

  const toggle = (slug) => {
    setSlugs((prev) =>
      prev.includes(slug)
        ? prev.filter((s) => s !== slug)
        : prev.length >= MAX
          ? prev
          : [...prev, slug]
    );
  };
  const has = (slug) => slugs.includes(slug);
  const clear = () => setSlugs([]);
  const remove = (slug) => setSlugs((prev) => prev.filter((s) => s !== slug));

  return (
    <CompareCtx.Provider value={{ slugs, toggle, has, clear, remove, max: MAX }}>
      {children}
    </CompareCtx.Provider>
  );
}

export const useCompare = () => useContext(CompareCtx);
